/* eslint-disable camelcase */
/* @flow strict */

/* eslint-disable react/jsx-handler-names */

import * as React from 'react';
import _ from 'lodash';
import i18next from 'i18next';
import Credentials from '/client/src/api/Credentials';
import { GET } from '/client/src/api';
import { ToggleOpacityOfContent } from '../utils/animation';
import LeftNavbar from './../components/leftNavbar/';
import TopNavbar from './../components/topNavbar/';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import Preloader from '/client/src/pages/Preloader';
import NProgressCustom from '/client/src/components/nProgress';
import SystemDialog from '/client/src/components/dialogs/system';
import GlobalError from '/client/src/pages/NotFound/GlobalError';
import WellcomeModal from '/client/src/components/dialogs/wellcome';
import { encrypt } from '/server/utils/encode';
import { encryptKey } from '/client/src/constants';
import { intercomeBoot } from '/client/src/utils/intercom';
import { PUT } from '/client/src/api';


import './styles/default.scss';

type PropsType = {
  children: React.Node,
  isEmpty: boolean,
  // isRedirect: null | string,
  toggleAuthenticateStatus: () => void
};

class DefaultContainer extends React.Component<PropsType> {
  props: PropsType;

  static getDerivedStateFromError = (error: any): {} => {
    console.error(error);

    return {
      hasError: true
    };
  };

  constructor(props: PropsType) {
    super(props);

    this.state = {
      profileCurrent: null,
      isShowSystemDialog: false,
      isShowWellcomeDialog: false,
      isShowStatusLeftMenu: true,
      systemDialogData: null,
      systemDialogType: '',
      systemDialogTitle: '',
      systemDialogContent: '',
      systemDialogCallback: false,
      systemDialogCancelCallback: false,
      systemDialogCallbackActions: ['Ok', 'Cancel'],
      hasError: false,
      completeStartRequest: false,
      isShowHeaderBanner: false,
      isOpenEditProfileModal: false,
      headerBannerContent: '',
      filterEventDashboard: [+window.localStorage.getItem('SPARXO_filterEventDashboard') || 0, 'type']
    };
  }

  componentDidCatch() {
    // TODO: Add Logger => logErrorToMyService(error, errorInfo);
  }

  componentDidMount() {
    if (!this.props.isEmpty) {
      this.getProfile();
    }

    const queryString = require('query-string');
    const isRedirectFromOldApp = _.get(queryString.parse(location.search), 'redirect-token', null);
    const isFirstSignIn = window.localStorage.getItem('isFirstSignIn');

    window.addEventListener('storage', ({ oldValue, newValue, key }: {oldValue: null | {}, newValue: null | {}}) => {
      if (key !== 'user') return;

      const _oldValue = oldValue ? JSON.parse(oldValue) : null;
      const _newValue = newValue ? JSON.parse(newValue) : null;

      if (!isRedirectFromOldApp && !isFirstSignIn) {
        if (_.get(_newValue, 'access_token', 1) !== _.get(_oldValue, 'access_token', 2)) {
          this.handleShowSystemDialog(true, {
            systemDialogType: 'error',
            systemDialogTitle: 'Hmmm...',
            systemDialogContent: 'You’ve Been Logged Out',
            systemDialogCallbackActions: ['Ok'],
            systemDialogCallback: () => {
              window.location.search = '';
              window.location.reload();
            }
          });
        } else if (!_.get(_oldValue, 'name', false)) {
          window.location.reload();
        }
      }
    });
  }

  componentDidUpdate(prevProps: PropsType, prevState: any): boolean | null {
    if (!!prevState.profileCurrent && prevProps.isEmpty) {
      this.setState({
        profileCurrent: false
      });

      this.getProfile();
    }

    if (prevProps.isEmpty) {
      this.getProfile();
    }
  }

  setProfileCurrent = (profileCurrent: {} | null) => {
    this.setState({
      profileCurrent
    });
  };

  handleSetFilterEventDashboard = (filter: []) => {
    this.setState({
      filterEventDashboard: filter
    }, () => {
      window.localStorage.setItem('SPARXO_filterEventDashboard', filter[0]);
    });
  };

  handleTurnOffWellcomeDialog = async () => {
    await PUT('/api/v1/1/merchants/organization_info_app', { show_welcome: false });
  }

  handleShowSystemDialog = (status: boolean, data: {}) => {
    const dialogOptionsDefault = {
      systemDialogData: null,
      systemDialogType: '',
      systemDialogTitle: '',
      systemDialogContent: '',
      systemDialogCallback: false,
      systemDialogCancelCallback: false,
      systemDialogCallbackActions: ['Ok', 'Cancel']
    };

    this.setState(data ? data : dialogOptionsDefault);

    this.setState({
      isShowSystemDialog: status
    });
  };

  getProfileRequest = async () => {
    try {
      const { result, success } = await GET('/api/v1/1/merchants/current');
      const user = await GET('/api/v1/1/account/current');

      let isShowWellcomeDialog;

      const isWellcomeDialogAlreadyShown = +window.localStorage.getItem('SPARXO_isShowWellcomeDialog');

      // Synchronise with the new backend wellcome dialog handling. Otherwise old users will shown a wellcome dialog again.
      if (isWellcomeDialogAlreadyShown) {
        isShowWellcomeDialog = false;
        window.localStorage.removeItem('SPARXO_isShowWellcomeDialog');

        this.handleTurnOffWellcomeDialog();
      } else {
        isShowWellcomeDialog = result.show_welcome;
      }

      this.setState({ completeStartRequest: true });

      if (success) {
        i18next.changeLanguage(result.lang, () => {
          setTimeout(() => {
            this.setState({
              profileCurrent: {
                ...result,
                roles: _.get(user, 'result.roles', [])
              },
              isShowWellcomeDialog
            });

            NProgressCustom(false);
          }, 500);
        });
      }
    } catch (e) {
      console.log('catch getProfileRequest', e);

      const errorStatus = _.get(e, 'status', false);

      if (errorStatus && errorStatus === 400) {
        // Credentials.logout();
      }

      this.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Hmmm...',
        systemDialogContent: 'Something went wrong.',
        systemDialogCallbackActions: ['Ok'],
        actionOkText: 'Reload page',
        systemDialogCallback: () => {
          window.location.search = '';
          window.location.reload();
        }
      });
    }
  };

  getProfile = () => {
    NProgressCustom(true);

    try {
      this.getProfileRequest();
      // NProgressCustom(false);
    } catch (error) {
      NProgressCustom(false);

      console.log(error);
      console.error('Can\'t get profile data');
    }
  };

  handleToggleWellcomeModal = (status: boolean) => {
    this.setState({
      isShowWellcomeDialog: status
    });
  };

  handleToggleLeftMenu = (isShowStatusLeftMenu: boolean) => {
    console.log('handleToggleLeftMenu', isShowStatusLeftMenu);
    this.setState({
      isShowStatusLeftMenu
    });
  }

  handleToggleHeaderBanner = (isShowHeaderBanner: boolean, headerBannerContent: any) => {
    this.setState({
      isShowHeaderBanner,
      headerBannerContent
    });
  }

  handleToggleEditProfileModal = (status: boolen) => {
    this.setState({
      isOpenEditProfileModal: status
    });
  }

  render(): React.Element<typeof React.Fragment> {
    const { isEmpty, children, toggleAuthenticateStatus } = this.props;
    const {
      hasError,
      profileCurrent,
      filterEventDashboard,
      isShowSystemDialog,
      isShowWellcomeDialog,
      systemDialogData,
      systemDialogType,
      systemDialogTitle,
      systemDialogContent,
      systemDialogCallback,
      systemDialogCancelCallback,
      systemDialogCallbackActions,
      completeStartRequest,
      isShowStatusLeftMenu,
      isShowHeaderBanner,
      headerBannerContent,
      isOpenEditProfileModal,
      actionOkText
    } = this.state;

    if (hasError) {
      return <GlobalError />;
    }

    if (isEmpty) {
      return children;
    }

    let redirectToken = null;

    if (profileCurrent) {
      const userData = Credentials.getUser();
      const data = {
        accessToken: userData ? userData.access_token : null,
        time: new Date().valueOf() // persistent ? null : new Date().valueOf()
      };
      const tokenCache = JSON.stringify(data);

      if (userData) {
        redirectToken = encrypt(tokenCache, encryptKey);
      }

      setTimeout(() => {
        ToggleOpacityOfContent(1);

        // if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line
          intercomeBoot(profileCurrent, { app_id: process.env.INTERCOM_ID });
        // }
      }, 100);
    }

    const removeBanner = () => {
      const BANNER = document.querySelector('.banner-notify');
      const WRAPPER = document.querySelector('.sparxo-layout');

      if (BANNER) {
        BANNER.style.display = 'none';
        WRAPPER.classList.remove('withBetaBanner');
        sessionStorage.setItem('hideBetaBanner', true);
      }
    };

    return (
      <>
        {!profileCurrent ?
          <Preloader completeStartRequest={completeStartRequest} /> :
          <DefaultContainerContext.Provider
            value={{
              profileCurrent,
              filterEventDashboard,
              setProfileCurrent: this.setProfileCurrent,
              handleGetProfile: this.getProfileRequest,
              handleShowSystemDialog: this.handleShowSystemDialog,
              handleSetFilterEventDashboard: this.handleSetFilterEventDashboard,
              handleToggleLeftMenu: this.handleToggleLeftMenu,
              handleToggleHeaderBanner: this.handleToggleHeaderBanner,
              handleToggleEditProfileModal: this.handleToggleEditProfileModal
            }}
          >
            <div
              className={`
                sparxo-layout
                layout-main
                not-collapsed
                ${!isShowStatusLeftMenu ? 'hide-menu' : ''}
                ${process.env.BETA_BANNER === 'true' && !JSON.parse(sessionStorage.getItem('hideBetaBanner')) ? 'withBetaBanner' : ''}
                ${isShowHeaderBanner ? 'withHeaderBanner' : ''}
                `}
            >
              <div className="sparxo-pages sparxo-sidebar-pages">

                <TopNavbar
                  toggleAuthenticateStatus={toggleAuthenticateStatus}
                  isShowHeaderBanner={isShowHeaderBanner}
                  headerBannerContent={headerBannerContent}
                  isOpenEditProfileModal={isOpenEditProfileModal}
                />

                 {process.env.BETA_BANNER === 'true' && !JSON.parse(sessionStorage.getItem('hideBetaBanner')) &&
                  <div className='banner-notify'>
                    <span>
                      You are using our new app.
                       We will let know when we will eventually retire the old one but for now,
                       you can always go back.
                    </span>
                    <span style={{ flexShrink: '0', paddingLeft: '10px' }}>
                      <a
                        href={`//${process.env.NODE_ENV === 'development' ? 'dev-nest' : 'nest'}.sparxo.com?redirect-token=${redirectToken}`}
                        target='_blank'
                        rel="noreferrer noopener"
                      >
                        Go back
                      </a>
                      <a
                        href='#'
                        style={{
                          padding: '0',
                          border: 0
                        }}
                        onClick={removeBanner}
                      >
                        <span style={{ fontSize: '2rem' }}>&times;</span>
                      </a>
                    </span>
                  </div>
                  }
                <LeftNavbar />
                {children}
              </div>
            </div>

            {isShowWellcomeDialog &&
              <WellcomeModal
                handleToggleWellcomeModal={this.handleToggleWellcomeModal}
              />
            }
          </DefaultContainerContext.Provider>
        }
        {isShowSystemDialog &&
          <SystemDialog
            type={systemDialogType}
            title={systemDialogTitle}
            content={systemDialogContent}
            data={systemDialogData}
            handleShow={this.handleShowSystemDialog}
            callback={systemDialogCallback}
            cancelCallback={systemDialogCancelCallback}
            actions={systemDialogCallbackActions}
            actionOkText={actionOkText}
          />
        }
      </>
    );
  }
}

export default DefaultContainer;
